import amazonLinks from '../config/amazonGeniusLinks.json';

/** Keep the API URL on the offer for freshness/notices; resolve only the click destination. */
export function getTrackedAmazonLink(href) {
  try {
    const url = new URL(href);
    if (url.origin !== 'https://www.amazon.com'
      || url.searchParams.get('tag') !== 'alextimm02-20'
      || !['ogi', 'osi'].includes(url.searchParams.get('linkCode'))) return href;
    const asin = url.pathname.match(/^\/dp\/([A-Z0-9]{10})\/?$/)?.[1];
    const link = amazonLinks[asin];
    return link ? `https://at.fish/${link.alias}` : href;
  } catch {
    return href;
  }
}
